import React, { useCallback, useContext, useEffect, useState, } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { PlayerUIContext, volumeOpen, volumeClose } from '@24i/player-ui';
import { VolumeContainer } from './styled';
import { VolumeButton } from './components/VolumeButton';
import { VolumeRocker } from './components/VolumeRocker';
export const Volume = ({ className = '', playerInstance, customIcon, disabled, styles = {
    container: null,
    button: {},
    rocker: {},
}, }) => {
    const { dispatch } = useContext(PlayerUIContext);
    const [isGestureInProgress, setGestureInProgress] = useState(false);
    const [delayedHide, setDelayedHide] = useState(false);
    const hide = useCallback(() => {
        if (isGestureInProgress) {
            setDelayedHide(true);
            return;
        }
        dispatch(volumeClose());
    }, [isGestureInProgress]);
    const [volume, setVolume] = useState(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.volume);
    const [muted, setMuted] = useState(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.muted);
    useEventListener('mutedchanged', (data) => {
        setMuted(data.muted);
    }, playerInstance);
    useEventListener('volumechange', (data) => {
        setVolume(data.volume);
    }, playerInstance);
    useEffect(() => {
        if (delayedHide && !isGestureInProgress) {
            hide();
            setDelayedHide(false);
        }
    }, [delayedHide, isGestureInProgress, hide]);
    const show = useCallback(() => {
        if (!isGestureInProgress) {
            dispatch(volumeOpen());
        }
    }, [dispatch, isGestureInProgress]);
    return (React.createElement(VolumeContainer, { style: styles.container, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, "data-test": "Volume", className: `Volume ${className}` },
        React.createElement(VolumeButton, { playerInstance,
            show,
            hide,
            muted,
            volume,
            customIcon,
            disabled, styles: styles.button }),
        React.createElement(VolumeRocker, { styles: styles.rocker, "data-test": "VolumeRocker", playerInstance,
            show,
            hide,
            setGestureInProgress,
            isGestureInProgress,
            muted,
            volume })));
};
export { VolumeContainer };
//# sourceMappingURL=index.js.map